import createIcon from '../../createIcon';

/**
 * @component @name NoDrinks
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41Mzk2MSAyLjI4OTYxSDIxLjcwOTZWNC4yODk2MUwxNS41MDk2IDExLjI1OTZMMTAuNTM5NiA2LjI4OTYxSDE3LjI3OTZMMTkuMDU5NiA0LjI4OTYxSDguNTM5NjFMNi41Mzk2MSAyLjI4OTYxWk0yMC40ODk2IDIxLjg5OTZMMTguNzA5NiAyMC4xMTk2VjIwLjI4OTZINi43MDk2MVYxOC4yODk2SDExLjcwOTZWMTMuMjg5NkwxMC4zMzk2IDExLjc0OTZMMi4wOTk2MSAzLjUwOTYxTDMuNTA5NjEgMi4wOTk2MUwzLjcwOTYxIDIuMjg5NjFMMjEuODk5NiAyMC40Nzk2TDIwLjQ4OTYgMjEuODk5NlpNMTYuODc5NiAxOC4yODk2TDEzLjcwOTYgMTUuMTE5NlYxOC4yODk2SDE2Ljg3OTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoDrinks = createIcon('NoDrinks', [
  [
    'path',
    {
      d: 'M6.53961 2.28961H21.7096V4.28961L15.5096 11.2596L10.5396 6.28961H17.2796L19.0596 4.28961H8.53961L6.53961 2.28961ZM20.4896 21.8996L18.7096 20.1196V20.2896H6.70961V18.2896H11.7096V13.2896L10.3396 11.7496L2.09961 3.50961L3.50961 2.09961L3.70961 2.28961L21.8996 20.4796L20.4896 21.8996ZM16.8796 18.2896L13.7096 15.1196V18.2896H16.8796Z',
      key: 'hjp8fd',
    },
  ],
]);

export default NoDrinks;
